export const API_URLS = {
  SIGNUP: "/pos/register",
  LOGOUT: "/pos/logout",
  CUSTOMER: "/app/v1/pos/customer?is_deleted=false",
  PRODUCT: "/app/v1/pos/product?is_deleted=False",
  ORDER: "/app/v1/pos/order",
  CATEGORY: "/app/v1/pos/category?is_deleted=False",
  STAFF: "/app/v1/pos/staff?is_deleted=false",
  USER: "/pos/add",
  BRANCH: "/app/v1/pos/branch?is_deleted=False",
  LEDGER: "/pos/ledger",
  PROFILE: "/pos/profile",
  PROFILE_IMAGE: "/pos/profile_images",
  THEME: "/pos/theme",
  REPORT: "/app/v1/import_export",
  SEND_EMAIL: "/app/v1/pos/orders_send_email",
};
